import { useEffect, useRef } from 'react';
import { isEmpty } from 'lodash-es';
import { useSelector } from 'umi';

export const EDIT_PAGE_KEY_MAP = {
  pipeline_gameDetails_gameInformation: 'pipelineGameDetailsGameInformation',
  pipeline_gameDetails_game_pillar: 'pipelineGameDetailsGamePillar',
  pipeline_gameDetails_elevator_pitch: 'pipelineGameDetailsElevatorPitch',
  pipeline_gameDetails_milestone_editGR: 'pipelineGameDetailsMilestoneEditGR',
  pipeline_gameDetails_update_info_edit: 'pipelineGameDetailsUpdateInfoEdit',
  pipeline_gameDetails_update_info_add: 'pipelineGameDetailsUpdateInfoAdd',
  pipeline_gameDetails_stakeholder_edit: 'pipelineGameDetailsStakeholderEdit',
  pipeline_gameDetails_tech_edit: 'pipelineGameDetailsTechEdit',
  pipeline_DPSNewsletter_edit: 'pipelineDPSNewsletterEdit',
  pipeline_DPSNewsletter_add: 'pipelineDPSNewsletterAdd',
  pipeline_DPSNewsletter_send_email: 'pipelineDPSNewsletterSendEmail',
  pipeline_GRAction_items_edit: 'pipelineGRActionItemsEdit',
  myWorkspace_addNewProduct: 'myWorkspaceAddNewProduct',
};

const DBG_SAVE_AUTO_EDIT_PARAMS = '__dbg_save_auto_edit_params__';

export function useAutoSaveParams(props: any) {
  const { initialParams, isBegin = false } = props;

  const { userInfo } = useSelector((state: any) => ({
    userInfo: state?.home?.userInfo,
  }));
  const { userid = '' } = userInfo || {};
  const timerRef = useRef(null);
  const saveParamsCurRef = useRef(props); // 每次渲染时更新ref
  const pageKeyPaCurRef = useRef(props); // 每次渲染时更新ref
  const isEditedRef = useRef(props); // 每次渲染时更新ref
  const isChangeValueRef = useRef(props); // 每次渲染时更新ref
  const useridCurRef = useRef(props); // 每次渲染时更新ref
  // 因setInterval闭包问题，需要使用useRef
  saveParamsCurRef.current = props.saveParamsCur;
  pageKeyPaCurRef.current = props.pageKey;
  useridCurRef.current = userid;
  // pageKeyPaCurRef.current = `${props.pageKey}_${userid}`;
  isEditedRef.current = props.isEdited || false;
  isChangeValueRef.current = props.isChangeValue || false;

  // 获取当前saveParamsMap
  const getSaveParamsMap = () => {
    const savedParamsText = localStorage.getItem(DBG_SAVE_AUTO_EDIT_PARAMS);
    const savedParamsMap = savedParamsText ? JSON.parse?.(savedParamsText) : {};
    return savedParamsMap;
  };

  // 获取当前pageKey下的saveParams
  const getSaveParamsValue = (pageKey: string = pageKeyPaCurRef.current) => {
    const savedParamsMap = getSaveParamsMap();
    const pageKeyValue = `${pageKey}_${useridCurRef.current}`;
    const saveParamsValue = savedParamsMap?.[pageKeyValue] || {};
    return saveParamsValue;
  };

  const getSaveParamsValueCur = (pageKey: string) => {
    const savedParamsMap = getSaveParamsMap();
    const saveParamsValue = savedParamsMap?.[pageKey] || {};
    return saveParamsValue;
  };

  // 是否需要弹窗提醒有自动保存内容
  const showRestorePrompt = (pageKey: string = pageKeyPaCurRef.current) => {
    const pageKeyValue = `${pageKey}_${useridCurRef.current}`;
    const saveParamsValue = getSaveParamsValueCur(pageKeyValue);
    if (!isEmpty(saveParamsValue)) {
      return true;
    }
    return false;
  };

  // 保存参数到localStorage
  const saveParams = () => {
    const pageKeyValue = `${pageKeyPaCurRef.current}_${useridCurRef.current}`;
    const saveParamsValue = getSaveParamsValueCur(pageKeyValue);
    if (
      (!isEmpty(initialParams) &&
        !isEmpty(saveParamsCurRef.current) &&
        isChangeValueRef?.current) ||
      isEditedRef.current
    ) {
      if (JSON.stringify(initialParams) !== JSON.stringify(saveParamsCurRef.current)) {
        if (JSON.stringify(saveParamsCurRef.current) !== JSON.stringify(saveParamsValue)) {
          const saveParamsmap = getSaveParamsMap();

          const paramsMapValue = {
            ...saveParamsmap,
            [pageKeyValue]: saveParamsCurRef.current,
          };
          localStorage.setItem(DBG_SAVE_AUTO_EDIT_PARAMS, JSON.stringify(paramsMapValue));
        }
      }
    }
  };

  useEffect(() => {
    if (!isEmpty(initialParams) && isBegin) {
      // 设置定时器每5秒保存一次
      timerRef.current = setInterval(saveParams, 5000);

      return () => {
        clearInterval(timerRef.current);
      };
    }
  }, [initialParams, isBegin]);

  // 保存参数到localStorage
  const deleteSaveParamsByPageKey = (pageKey: string = pageKeyPaCurRef.current) => {
    const pageKeyValue = `${pageKey}_${useridCurRef.current}`;

    const saveParamsmap = getSaveParamsMap();
    delete saveParamsmap[pageKeyValue];
    localStorage.setItem(DBG_SAVE_AUTO_EDIT_PARAMS, JSON.stringify(saveParamsmap));
  };

  return {
    getSaveParamsValue,
    showRestorePrompt,
    deleteSaveParamsByPageKey,
  };
}
